const calculateAge = (date: string): number => {
  const today: Date = new Date();
  const birthDate: Date = new Date(date);
  let age: number = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age-=1;
  }
  return age;
};

export default calculateAge;
